import "./ProfTestCreate.css";

import React from "react";
import { api } from "../../api/api";
import { appActions } from "../../store/slices/appSlice";
import { useAppDispatch } from "../../store";

export default function ProfTestCreate() {
  const buttonRef = React.useRef<HTMLButtonElement>(null);
  const [status, setStatus] = React.useState<
    "pending" | "loading" | "success" | "error"
  >("pending");
  const [email, setEmail] = React.useState<string>("");
  const [testUrl, setTestUrl] = React.useState<string>();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(appActions.theme("light"));
  }, [dispatch]);

  const onSubmit = () => {
    setStatus("loading");
    api.exam.create(email).then((resp) => {
      setStatus(resp.status);
      if (resp.status === "success") {
        setTestUrl(resp.test?.url);
      }
    });
  };

  const change = (evt: any) => {
    const { value } = evt.target;
    setEmail(value?.trim());
    if (buttonRef.current) {
      if (value.match(/.+@.+\..+/)) {
        buttonRef.current.classList.remove("disabled");
      } else {
        buttonRef.current.classList.add("disabled");
      }
    }
  };

  const renderPending = () => (
    <div className="content">
      <div className="prof-test-create">
        <div className="grid-item grid-text">Email</div>
        <div className="grid-item">
          <input type="text" value={email} size={50} onChange={change} />
        </div>
        <div className="grid-item">
          <button
            ref={buttonRef}
            className="loa-button loa-button-primary disabled"
            type="button"
            onClick={onSubmit}
          >
            Generate Test
          </button>
        </div>
      </div>
    </div>
  );

  const renderLoading = () => <div className="loading-status">Loading...</div>;

  const renderSuccess = () => (
    <div className="success-status">
      <p className="center">
        Check your <b>{email}</b> for a link to your test!
      </p>
      <p className="center">
        If you don't receive the email then check your spam folder or go back
        and send it again.
      </p>
      <p className="center">
        Contact us at{" "}
        <a href="mailto:admin@loalanguageshool.is">
          admin@loalanguageschool.is
        </a>{" "}
        if you have any problems.
      </p>
      <p className="center">
        <button className="loa-button" onClick={() => setStatus("pending")}>
          Go back
        </button>
      </p>
    </div>
  );

  const renderError = () => (
    <div className="container">
      <p className="warning">
        Oops! We failed to send an email to <b>{email}. </b>
      </p>
      <p className="center">
        Please enter the correct email address if this one is not correct
        <br />
        or just goto the test (if you are certain the email address is correct):
      </p>
      <div className="grid auto-auto">
        <button className="loa-button" onClick={() => setStatus("pending")}>
          &lt; Enter email again
        </button>
        <button className="loa-button" onClick={() => window.open(testUrl)}>
          Go to test
        </button>
      </div>
    </div>
  );

  const renderStatus = () => {
    switch (status) {
      case "pending":
        return renderPending();
      case "loading":
        return renderLoading();
      case "success":
        return renderSuccess();
      case "error":
        return renderError();
      default:
        return <div>Unknown status: {status}</div>;
    }
  };

  return renderStatus();
}
